import { useRouteMatch } from 'react-router-dom';

import useHeroDiscoveriesWithAutoFetching from '@lootboy/lib/slices/discoveries/useHeroDiscoveriesWithAutoFetching';

import IconWithNotifications from '~/components/IconWithNotifications';

import { HERO_PATH } from '~/routes/paths';

import { ReactComponent as HeroIcon } from '~/assets/images/iconsLibrary/fire.svg';

function HeroTabIcon({ className }: { className: string }): JSX.Element {
  const { newContentFetched } = useHeroDiscoveriesWithAutoFetching();
  const heroPageMatch = useRouteMatch({ path: HERO_PATH });

  return (
    <IconWithNotifications
      showBadge={newContentFetched && !heroPageMatch}
      Svg={HeroIcon}
      className={className}
    />
  );
}

export default HeroTabIcon;
